<template>
    <div class="">
        <div
            class="mb-4 flex items-center gap-4 rounded bg-green-400 p-2 text-white"
            v-if="successMessage !== null"
        >
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.875 9C0.875 4.5125 4.5125 0.875 9 0.875C13.4875 0.875 17.125 4.5125 17.125 9C17.125 13.4875 13.4875 17.125 9 17.125C4.5125 17.125 0.875 13.4875 0.875 9ZM12.0083 7.48833C12.0583 7.42171 12.0945 7.34576 12.1147 7.26496C12.135 7.18415 12.1388 7.10012 12.1261 7.0178C12.1134 6.93547 12.0844 6.85652 12.0407 6.78558C11.9971 6.71464 11.9396 6.65315 11.8719 6.60471C11.8041 6.55627 11.7273 6.52187 11.6461 6.50352C11.5648 6.48518 11.4807 6.48326 11.3987 6.49789C11.3167 6.51251 11.2385 6.54338 11.1686 6.58868C11.0987 6.63398 11.0385 6.69279 10.9917 6.76167L8.295 10.5367L6.94167 9.18333C6.82319 9.07293 6.66648 9.01283 6.50456 9.01569C6.34265 9.01854 6.18816 9.08414 6.07365 9.19865C5.95914 9.31316 5.89354 9.46765 5.89069 9.62956C5.88783 9.79148 5.94793 9.94819 6.05833 10.0667L7.93333 11.9417C7.99749 12.0058 8.07483 12.0552 8.15999 12.0864C8.24515 12.1176 8.33608 12.1299 8.42647 12.1224C8.51686 12.115 8.60455 12.088 8.68344 12.0432C8.76233 11.9985 8.83054 11.9371 8.88333 11.8633L12.0083 7.48833Z"
                    fill="white"
                />
            </svg>

            <div>
                <span v-html="successMessage" />
            </div>
            <div class="ml-auto p-2" @click="successMessage = null">
                <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M0.557783 0.558298C0.674971 0.441256 0.833824 0.375515 0.99945 0.375515C1.16508 0.375515 1.32393 0.441256 1.44112 0.558298L5.99945 5.11663L10.5578 0.558298C10.615 0.496893 10.684 0.447641 10.7607 0.413481C10.8373 0.379321 10.9201 0.360953 11.004 0.359472C11.0879 0.357992 11.1713 0.373429 11.2491 0.404863C11.3269 0.436297 11.3976 0.483084 11.457 0.542433C11.5163 0.601782 11.5631 0.672477 11.5946 0.7503C11.626 0.828124 11.6414 0.911481 11.6399 0.995401C11.6385 1.07932 11.6201 1.16208 11.5859 1.23875C11.5518 1.31541 11.5025 1.38441 11.4411 1.44163L6.88278 5.99997L11.4411 10.5583C11.5025 10.6155 11.5518 10.6845 11.5859 10.7612C11.6201 10.8378 11.6385 10.9206 11.6399 11.0045C11.6414 11.0884 11.626 11.1718 11.5946 11.2496C11.5631 11.3275 11.5163 11.3981 11.457 11.4575C11.3976 11.5168 11.3269 11.5636 11.2491 11.5951C11.1713 11.6265 11.0879 11.6419 11.004 11.6405C10.9201 11.639 10.8373 11.6206 10.7607 11.5864C10.684 11.5523 10.615 11.503 10.5578 11.4416L5.99945 6.8833L1.44112 11.4416C1.32264 11.552 1.16593 11.6121 1.00401 11.6093C0.842097 11.6064 0.687609 11.5408 0.573098 11.4263C0.458588 11.3118 0.392994 11.1573 0.390138 10.9954C0.387281 10.8335 0.447383 10.6768 0.557783 10.5583L5.11612 5.99997L0.557783 1.44163C0.440741 1.32444 0.375 1.16559 0.375 0.999965C0.375 0.83434 0.440741 0.675486 0.557783 0.558298Z"
                        fill="white"
                    />
                </svg>
            </div>
        </div>
        <form @submit.prevent="submitForm">
            <div class="flex flex-col lg:flex-row justify-between" >
                <div class="flex flex-col w-full lg:w-1/3">
                    <form-input
                        type="email"
                        v-model="form.email"
                        label="Email"
                        name="email"
                    />
                </div>
                <div class="flex flex-col">
                    <form-select
                        v-model="form.membershipPlanId"
                        label="Membership Plan"
                        name="membershipPlanId"
                        :options="membershipPlanOptions"
                    />
                </div>
                <div class="flex flex-col w-full lg:w-1/7">
                    <form-select
                        v-model="form.providerLevelId"
                        label="Provider Level"
                        name="providerLevelId"
                        :options="providerLevelOptions"
                        v-on:update:modelValue="levelChange"
                    />
                </div>
                <div class="flex flex-col w-full lg:w-1/4" v-if="!forceClassroomId">
                    <div class="relative w-full">
                        <label class="mb-2 block text-[14px] font-semibold">
                            Classroom
                            <span class="text-gray-650">(Optional)</span>
                        </label>
                        <div class="relative flex w-full items-center">
                            <GroupStudentClassroomSelect
                                :classroom-options="classroomOptions"
                                v-model="form.classroomId"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="">
                <hr />
                <div class="mt-4 flex items-center justify-end gap-4">
                    <div class="btn btn-outline" @click="cancel()">Cancel</div>
                    <button
                        :class="
                            'btn' +
                            ' ' +
                            (form.isDirty ? 'btn-primary' : 'btn-disabled')
                        "
                    >
                        Add student
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import FormInput from "@/Components/FormInput";
import FormSelect from "@/Components/FormSelect";
import GroupStudentClassroomSelectAndChange from "@/Components/GroupStudentClassroomSelectAndChange.vue";
import GroupStudentClassroomSelect from "@/Pages/GroupBackend/GroupStudentClassroomSelect.vue";

export default {
    name: "GroupInviteNewStudentForm",
    components: {
        GroupStudentClassroomSelect,
        GroupStudentClassroomSelectAndChange,
        FormSelect,
        FormInput,
    },
    emits: ["cancel", "levelChange"],
    props: {
        forceClassroomId: {
            type: Number,
            default: null,
        },
        level: {
            type: Number,
            default: null,
        }
    },
    data() {
        // The id is not zero because that makes the <select> look different.
        // If more options are added, increment "5" here and in `created()`.
        // Value in controller must be updated also.
        const opts = this.$page.props.providerLevelOptions;

        // Dev hot reload was prepending multiple
        if (opts.length < 5) {
            opts.unshift({ value: 5, label: "--" });
        }

        return {
            successMessage: null,
            providerLevelOptions: opts,
            membershipPlanOptions: null,
            form: this.$inertia.form({
                email: null,
                membershipPlanId: null,
                providerLevelId: null,
            }),
        };
    },
    created() {
        this.classroomOptions = this.$page.props.classroomOptions;
        this.membershipPlanOptions = this.$page.props.membershipPlanOptions;
        this.form.membershipPlanId = this.membershipPlanOptions[0].id;
        this.form.providerLevelId = this.level || 5;
        this.form.classroomId = this.forceClassroomId;
    },
    methods: {
        levelChange(val) {
            this.$emit('levelChange', val);
        },
        submitForm() {
            let vm = this;

            this.$inertia.post(
                route("group.student.invite"),
                {
                    email: vm.form.email,
                    providerLevelId: vm.form.providerLevelId,
                    membershipPlanId: vm.form.membershipPlanId,
                    classroomId: vm.form.classroomId,
                },
                {
                    onSuccess() {
                        vm.membershipPlanOptions =
                            vm.$page.props.membershipPlanOptions;
                        vm.successMessage =
                            "Your invite to <span class='font-bold'>" +
                            vm.form.email +
                            "</span> has been sent";

                        setTimeout(function () {
                            vm.successMessage = null;
                        }, 2000);

                        vm.form.email = "";
                    },
                }
            );
        },
        cancel() {
            this.form.reset;
            this.$emit("cancel");
        },
    },
    mounted() {},
};
</script>
